export const content = {
    form: {
        name: { en: 'Name', hy: 'Անուն' },
        email: { en: 'E-mail', hy: 'Էլ․ հասցե' },
        message: { en: 'Message', hy: 'Հաղորդակցություն' },
        send: { en: 'Send', hy: 'Ուղարկել' }
    },
    info: {
        social: { en: 'Social Media', hy: 'Սոցիալական Ցանցեր' }
    }
}
